import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

import toast from "react-hot-toast";
import Select from "react-select";
import DestinationWidgetService from "../../../services/KangarooServices/Intelligence/DestinationWidgetService";
import UniversityService from "../../../services/KangarooServices/UniversityService";
import WidgetService from "../../../services/KangarooServices/Intelligence/WidgetService";
import DestinationService from "../../../services/KangarooServices/DestinationService";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";

const DestinationWidgetForm = ({ isOpen, toggle, selectedItem, fetchData }) => {
  console.log("🚀 ~ DestinationWidgetForm ~ selectedItem:", selectedItem);
  const [institutedata, setInstituteData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [widgetData, setWidgetData] = useState([]);
  console.log("🚀 ~ DestinationWidgetForm ~ widgetData:", widgetData);
  const authUser = getLoggedInUser();
  const isSuperAdmin = authUser.roles[0].includes("SuperAdmin");
  const isOnshoreAdmin = authUser.roles[0].includes("OnshoreAdmin");
  const isOffshoreAdmin = authUser.roles.includes("OffshoreAdmin");

  const isOnshorePage = isOnshoreAdmin ? true : isOffshoreAdmin ? false : null;
  const fetchWidgetData = async (page = 1, size = 1000) => {
    try {
      const response = await WidgetService.getList({
        isOnshore: isOnshorePage,
        page,
        pageSize: size,
      });
      setWidgetData(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchWidgetData();
  }, []);
  const formik = useFormik({
    initialValues: {
      destinationCountryIds: selectedItem?.destinationCountryId
        ? [String(selectedItem.destinationCountryId)]
        : [],
      widgetIds: Array.isArray(selectedItem?.widgets)
        ? selectedItem.widgets.map((w) => String(w.widgetId))
        : [],
    },
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        if (selectedItem?.destinationCountryId) {
          await DestinationWidgetService.update(
            selectedItem.destinationCountryId,
            values,
          );
          toast.success("Form updated successfully");
        } else {
          await DestinationWidgetService.create(values);
          toast.success("Form created successfully");
        }
        resetForm();
        fetchData();
        toggle();
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong!");
      }
    },
  });

  const fetchUniversityData = async () => {
    setLoading(true);
    try {
      const response = await DestinationService.getList();
      setInstituteData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUniversityData();
  }, []);

  const instituteOptions = institutedata?.map((i) => ({
    value: String(i.id),
    label: i.name,
  }));

  const widgetOptions = [
    ...widgetData?.map((type) => ({
      value: type.id,
      label: type.name,
    })),
    ...(selectedItem?.widgets?.map((w) => ({
      value: w.id,
      label: w.name,
    })) || []),
  ];
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Destination Widget</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <Label>Destination</Label>
            <Select
              isMulti
              options={instituteOptions}
              value={instituteOptions?.filter((opt) =>
                formik.values.destinationCountryIds.includes(opt.value),
              )}
              onChange={(selected) =>
                formik.setFieldValue(
                  "destinationCountryIds",
                  selected ? selected.map((s) => s.value) : [],
                )
              }
              placeholder="Select destination country"
            />
          </div>
          <div className="mb-3">
            <Label>Widget</Label>

            <Select
              isMulti
              options={widgetOptions}
              value={
                formik.values.widgetIds
                  .map((id) => widgetOptions.find((opt) => opt.value === id))
                  .filter(Boolean) // just in case some IDs are missing
              }
              onChange={(selected) =>
                formik.setFieldValue(
                  "widgetIds",
                  selected ? selected.map((s) => s.value) : [],
                )
              }
              placeholder="Select widget"
            />
          </div>

          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {selectedItem?.destinationCountryId ? "Update" : "Create"}
            </button>
            <button type="button" className="btn btn-danger" onClick={toggle}>
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default DestinationWidgetForm;
